'use client';
import { memo, useCallback } from 'react';
import { AppIconNpayOn, AppIconNaverOn } from '@defign/ui';
import { getPayAppUrl, getNaverAppUrl } from '@financial/app-js-interfaces';
import { HalfLayerWrapper } from '@financial/common-styled-elements';
import { Phase } from '@financial/service-origins';
import classNames from '../node_modules/.pnpm/classnames@2.5.1/node_modules/classnames/bind.mjs';
import { convertPhase } from '../share/utils.mjs';
import style from './BottomLayer.module.mjs';
import LayerTitle from './LayerTitle.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

const cx = classNames.bind(style);
const BottomLayer = /*#__PURE__*/memo(function BottomLayer(_ref) {
  let {
    isShow = false,
    landingUrl = 'https://new-m.pay.naver.com/mydata/home',
    onClose = () => {},
    phase = Phase.real,
    serviceMenuOption = {
      menuName: 'myasset',
      url: ''
    },
    supportApps = ['naverapp', 'payapp'],
    naverAppDescription = '생활 속 도구를 하나로',
    payAppDescription = '앱 잠금으로 안전한 자산관리',
    onNaverAppClick,
    onPayAppClick,
    isIOS,
    inappbrowser = false
  } = _ref;
  const handleOpenPayApp = useCallback(() => {
    if (onPayAppClick) {
      onPayAppClick();
      return;
    }
    window.location.href = getPayAppUrl({
      phase: convertPhase(phase),
      deviceType: isIOS ? 'ios' : 'android',
      ...(inappbrowser ? {
        shouldInAppBrowserOpen: inappbrowser,
        landingUrl
      } : {
        shouldInAppBrowserOpen: inappbrowser,
        serviceMenuOption
      })
    });
  }, [inappbrowser, isIOS, landingUrl, onPayAppClick, phase, serviceMenuOption]);
  const handleOpenNaverApp = useCallback(() => {
    if (onNaverAppClick) {
      onNaverAppClick();
      return;
    }
    window.location.href = getNaverAppUrl({
      landingUrl,
      deviceType: isIOS ? 'ios' : 'android'
    });
  }, [isIOS, landingUrl, onNaverAppClick]);
  if (supportApps.length === 0) {
    return null;
  }
  return (
    /*#__PURE__*/
    // https://oss.fin.navercorp.com/finance-fe/deFign/blob/f2d21948dde9cf044d239c32d8276d842d30e596/packages/ui/src/components/bottomNavigationBar/BottomNavigationBar.module.scss#L65-L67 얘 보다 높아야함
    jsx(HalfLayerWrapper, {
      isShow: isShow,
      onClose: onClose,
      showCloseButton: true,
      zIndex: 3001,
      children: /*#__PURE__*/jsxs("div", {
        className: cx('article'),
        children: [/*#__PURE__*/jsx(LayerTitle, {
          title: "\uC571\uC73C\uB85C \uC5F4\uAE30"
        }), /*#__PURE__*/jsxs("ul", {
          className: cx('list'),
          children: [supportApps.includes('payapp') ? /*#__PURE__*/jsxs("li", {
            className: cx('item'),
            children: [/*#__PURE__*/jsxs("span", {
              className: cx('icon'),
              children: [/*#__PURE__*/jsx(AppIconNpayOn, {
                width: 49,
                height: 49
              }), /*#__PURE__*/jsx("span", {
                className: "blind",
                children: "\uB124\uC774\uBC84\uD398\uC774\uC571 \uC544\uC774\uCF58"
              })]
            }), /*#__PURE__*/jsxs("span", {
              className: cx('text-area'),
              children: [/*#__PURE__*/jsx("strong", {
                className: cx('name'),
                children: "\uB124\uC774\uBC84\uD398\uC774"
              }), " ", payAppDescription]
            }), /*#__PURE__*/jsx("button", {
              type: "button",
              className: cx('button', 'type-green-button'),
              onClick: handleOpenPayApp,
              children: "\uC5F4\uAE30"
            })]
          }) : null, supportApps.includes('naverapp') ? /*#__PURE__*/jsxs("li", {
            className: cx('item'),
            children: [/*#__PURE__*/jsxs("span", {
              className: cx('icon'),
              children: [/*#__PURE__*/jsx(AppIconNaverOn, {
                width: 49,
                height: 49
              }), /*#__PURE__*/jsx("span", {
                className: "blind",
                children: "\uB124\uC774\uBC84\uC571 \uC544\uC774\uCF58"
              })]
            }), /*#__PURE__*/jsxs("span", {
              className: cx('text-area'),
              children: [/*#__PURE__*/jsx("strong", {
                className: cx('name'),
                children: "\uB124\uC774\uBC84"
              }), " ", naverAppDescription]
            }), /*#__PURE__*/jsx("button", {
              type: "button",
              className: cx('button'),
              onClick: handleOpenNaverApp,
              children: "\uC5F4\uAE30"
            })]
          }) : null]
        })]
      })
    })
  );
});
var BottomLayer$1 = BottomLayer;

export { BottomLayer$1 as default };
